export default __webpack_public_path__ + "static/media/bathroom3.3208fa59.jpg";